import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container,Card,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import '../focusUtils';
const HpPrograms = () => 
{
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[stickyPrograms,setPrograms]=useState([]);
    useEffect(()=>
    {
        const stickyPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/sticky");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.p_id + "/programImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].programImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].programImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setPrograms(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Programs Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setPrograms([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true )
                {
                    console.info('Programs : Result',result);
                }
              
            } catch (error) 
            {
                console.error('Programs : Error', error.message);
                setLoading(false);
            }
        };
        stickyPrograms();
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides(); 
    },[])
    const settings = {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: false,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    return (
        <section className="hp-programs bg-info-subtle">
            <Container className="py-md-5 py-4 text-center">
                <h2 className='text-dark'>{t('Programs')}</h2>
                <span className="mb-4 sub-heading"></span>
                {isLoading ? (
                    <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                        <Slider {...settings}>
                            {[...Array(5)].map((_,index)=>(
                            <div className='p-3' key={index}>
                                <Card className='text-center card-custom'>
                                    <Placeholder xs={12} className="card-img-top" style={{minHeight:"160px"}} />
                                    <Card.Body>
                                        <Placeholder xs={10} />
                                    </Card.Body>
                                    <Card.Footer className='text-bg-info'>
                                        <Placeholder xs={10} />
                                    </Card.Footer>
                                </Card>
                            </div>
                            ))}
                        </Slider>
                    </div>
                ) : (
                    <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                        <Slider {...settings}>
                            {stickyPrograms.map((sp, index)=>(
                                sp.p_sticky === 1 ? (
                                <div className='p-3' key={index}>
                                    <Card className='text-center card-custom'>
                                        {appLanguage === 'hi' ? 
                                            (
                                                sp.programImageHi 
                                                ? <Card.Img variant="top" className="img-fluid" src={sp.programImageHi} width={260} height={160} alt={`${sp.p_name_hi} प्रोग्राम`} loading="lazy" /> 
                                                : sp.programImage 
                                                    ? <Card.Img variant="top" className="img-fluid" src={sp.programImage} width={260} height={160} alt={`${sp.p_name_hi} प्रोग्राम`} loading="lazy" /> 
                                                    : <Placeholder xs={12} className="card-img-top" width={260} height={160} />
                                            ) : (
                                                sp.programImage 
                                                ? <Card.Img variant="top" className="img-fluid" src={sp.programImage} width={260} height={160} alt={`${sp.p_name} program`} loading="lazy" /> 
                                                : <Placeholder xs={12} className="card-img-top" width={260} height={160} />
                                            )
                                        }
                                        <Card.Body>
                                            <Card.Title className='fs-6 mb-0'>
                                                { appLanguage === 'hi' ? sp.p_name_hi || sp.p_name : sp.p_name }
                                            </Card.Title>
                                        </Card.Body>
                                        <Card.Footer className='text-bg-info'>
                                            <NavLink to={appLanguage === 'hi' ? `/प्रोग्राम/विवरण/${sp.p_htaccess_hi || sp.p_htaccess}` : `/program/details/${sp.p_htaccess}`} className='link-light' target='_blank' rel="noopener noreferrer">
                                                { appLanguage === 'hi' ? sp.programType.pt_name_hi || sp.programType.pt_name : sp.programType.pt_name } <i className="bi bi-arrow-right-short"></i>
                                            </NavLink>                                                            
                                        </Card.Footer>
                                    </Card>
                                </div>
                                ) : null
                            ))}
                        </Slider>
                    </div>
                )}
            </Container>
        </section>
    );    
}
export default HpPrograms;